import { i18n } from "@tellescope/i18n";
import { CustomFieldValue } from "./FieldsBlock/FieldCell/CustomFieldEditor";
import { parseDateInput } from "@tellescope/utils";

// TODO: replace with the abstracted design-system custom-field read-only display once one exists.
export const getCustomFieldDisplay = (type: string, value: CustomFieldValue): string => {
  switch (type) {
    case "Number":
      return typeof value === "number" ? String(value) : typeof value === "string" ? value : "";
    case "Date": {
      const parsed = parseDateInput(typeof value === "string" ? value : "");
      return parsed ? `${parsed.getMonth() + 1}/${parsed.getDate()}/${parsed.getFullYear()}` : "";
    }
    case "Multiple Select":
    case "Multiple Text":
      return Array.isArray(value) ? value.filter((v): v is string => typeof v === "string").join(", ") : "";
    case "Checkbox":
      return typeof value === "string" && value.startsWith("checkbox:") ? i18n.t("Yes") : i18n.t("No");
    default:
      return typeof value === "string" ? value : "";
  }
};
